import { Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ReactComponent from '@/components/ReactComponent';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ModalRelatorioProcessos from './Relatorios/ModalRelatorioProcessos';
import { ContentPasteGo } from '@mui/icons-material';
import ModalPendenciasConferencia from './Relatorios/ModalPendenciasConferencia';
import ExportarProcessosParaArquivoCsv from '../ExportarProcessosParaArquivoCsv';

const RELATORIO_LISTA_PROCESSOS = 'listaProcessos';
const RELATORIO_PENDENCIAS_CONFERENCIA = 'pendenciasConferencia';

class ExportarRelatoriosProcessosFiltrados extends ReactComponent {
    cursor = 'pointer';
    cpfSignatario;
    anchorElExportarRelatorios = null;
    openMenuExportarRelatorios = Boolean(this.anchorElExportarRelatorios);

    openRelatorio = { [RELATORIO_LISTA_PROCESSOS]: false, [RELATORIO_PENDENCIAS_CONFERENCIA]: false };

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            cpfSignatario: observable,
            anchorElExportarRelatorios: observable,
            openMenuExportarRelatorios: observable,
            openRelatorio: observable,
            handleClickMenu: action,
            handleCloseMenu: action,
            handleOpenRelatorio: action,
            handleCloseRelatorio: action,
            temFiltroAtivo: computed
        });
    }

    handleClickMenu = (event) => {
        this.anchorElExportarRelatorios = event.currentTarget;
        this.openMenuExportarRelatorios = true;
    };

    handleCloseMenu = () => {
        this.anchorElExportarRelatorios = null;
        this.openMenuExportarRelatorios = false;
    };

    handleOpenRelatorio = (relatorio) => {
        this.openMenuExportarRelatorios = false;
        this.openRelatorio[relatorio] = true;
    };

    handleCloseRelatorio = (relatorio) => {
        this.openRelatorio[relatorio] = false;
    };

    get temFiltroAtivo() {
        return Array.isArray(this.store.filtros?.filtrosComValor) && this.store.filtros.filtrosComValor.length > 0;
    }

    render() {
        const menuId = 'exportar-relatorios';
        const filtrados = this.temFiltroAtivo ? ' filtrados' : '';

        return (
            <>
                <Tooltip title={<Typography>{`Relatórios dos processos${filtrados}`}</Typography>}>
                    <IconButton
                        data-testid="abrirMenuExportarRelatorios"
                        id="iconeExportarRelatorios"
                        aria-label={`Relatórios dos processos${filtrados}`}
                        sx={{ p: 0, mr: 0.5 }}
                        className="corBotao"
                        onClick={this.handleClickMenu}
                    >
                        <ContentPasteGo className="corBotao" />
                    </IconButton>
                </Tooltip>
                <Menu
                    id={menuId}
                    anchorEl={this.anchorElExportarRelatorios}
                    open={this.openMenuExportarRelatorios}
                    onClose={this.handleCloseMenu}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    sx={{ mt: 1 }}
                >
                    <MenuItem sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <ExportarProcessosParaArquivoCsv botaoTexto />
                    </MenuItem>
                    <MenuItem
                        onClick={() => this.handleOpenRelatorio(RELATORIO_LISTA_PROCESSOS)}
                        sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                    >
                        <Typography>Planilha de julgamento</Typography>
                    </MenuItem>
                    <MenuItem
                        onClick={() => this.handleOpenRelatorio(RELATORIO_PENDENCIAS_CONFERENCIA)}
                        sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                    >
                        <Typography>Pendências de conferência</Typography>
                    </MenuItem>
                </Menu>

                {!!this.openRelatorio[RELATORIO_LISTA_PROCESSOS] && (
                    <ModalRelatorioProcessos
                        openModalImpressao={true}
                        onCloseModalImpressao={() => this.handleCloseRelatorio(RELATORIO_LISTA_PROCESSOS)}
                    />
                )}

                {!!this.openRelatorio[RELATORIO_PENDENCIAS_CONFERENCIA] && (
                    <ModalPendenciasConferencia
                        openModalImpressao={true}
                        onCloseModalImpressao={() => this.handleCloseRelatorio(RELATORIO_PENDENCIAS_CONFERENCIA)}
                    />
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ExportarRelatoriosProcessosFiltrados));
